import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { getPetsByAccount, setPetsDataRefresh } from "../../store/actions/pets-actions";
import { getAccountInfo, setAccountDataRefresh } from "../../store/actions/accounts-actions";
import { setNewRoute, getAlertsByAccount } from "../../store/actions/alerts-actions";
import { setDocumentsDataRefresh } from "../../store/actions/documents-actions";

import Stepper from "../common/stepper/Stepper";
import Loader from "../common/loader/Loader";

import CancelComponent from "./cancelComponent/cancel-component";
import CancelConfirm from "./cancelConfirm/CancelConfirm";

import Util from "../common/util/util";

import "./cancel-policy.css";

class CancelPolicy extends Component {
  constructor() {
    super();
    this.state = {
      formData: null,
      expiryDate: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.actions.getPetsByAccount();
  }

  setData = (formData, expiryDate) => {
    this.setState({
      formData: formData,
      expiryDate: expiryDate
    });
  };

  render() {

    /*
      let petDetailsText = this.state.formData.values.accountOrPetID
      this.props.petDetails && this.props.petDetails.length > 0
        ? Util.getCommaSeperatedNameString(
            this.props.petDetails.map(pet => {
              return pet.Name;
            })
          )
        : "your pets ";
    */

    return (
      <div
        style={{ position: this.props.canUserEdit ? "static" : "relative" }}
        className="cancel-parent-container"
      >
        {this.props.canUserEdit ? null : <div className="disable-user-edit" />}
        {this.props.fetchingPets || this.props.userAccountDetailsFetching ? (
          <Loader position="absolute" fullPage={true}/>
        ) : (
          <Stepper hasSuccess={false} headerTitle="Cancel Account">
            <Stepper.Step>
              <CancelComponent
                {...this.props}
                setNewRoute={this.props.actions.setNewRoute}
                setData={this.setData}
              />
            </Stepper.Step>
            <Stepper.Step>
              <CancelConfirm
                {...this.props}
                formData={this.state.formData}
                expiryDate={this.state.expiryDate}
                setNewRoute={this.props.actions.setNewRoute}
                setPetsDataRefresh={this.props.actions.setPetsDataRefresh}
                getPetsByAccount={this.props.actions.getPetsByAccount}
                setAccountDataRefresh={this.props.actions.setAccountDataRefresh}
                getAlertsByAccount={this.props.actions.getAlertsByAccount}
                getAccountInfo={this.props.actions.getAccountInfo}
                setDocumentsDataRefresh={this.props.actions.setDocumentsDataRefresh}
              />
            </Stepper.Step>
          </Stepper>
        )}
      </div>
    );
  }
}

// TODO: Bind PetDetail Fetching from Redux
const mapStateToProps = state => ({
  fetchingPets: state.pets.fetchingPets,
  petDetails: state.pets.petsDetails.filter(pet => pet.Status === "Active"),
  canUserEdit: state.account.canUserEdit,
  userAccountDetails: state.account.userAccountDetails,
  userAccountDetailsFetching: state.account.fetching
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    { getPetsByAccount, 
      getAccountInfo, 
      setNewRoute,
      setPetsDataRefresh,
      setAccountDataRefresh,
      getAlertsByAccount,
      setDocumentsDataRefresh,
     },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelPolicy);
